module.exports = __webpack_public_path__ + "img/DSC_5154.d35e430a.jpg";